import { Col, Row, Form, Breadcrumb, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { GeneralAdd } from "./GeneralAdd";
import { useMutation } from "react-query";
import { createWarehouse, editWarehouse } from "../../api/warehouse";
import { warehouseType } from "./WarehouseType";
import { Link } from "react-router-dom";
import AddEditButton from "../UI/AddEditButton/addeditbutton";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import { message } from "antd";

function AddEditWarehouses() {
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [key, setKey] = useState("1");
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [name, setName] = useState(false);
  const location = useLocation();
  const warehouse = location?.state?.warehouse;
  const isEdit = () => {
    return !!id;
  };

  const items = [
    {
      key: "1",
      label: `${t("general-information")}`,
      children: (
        <GeneralAdd setName={setName} isEdit={isEdit} warehouse={warehouse} />
      ),
    },
  ];
  const [activeTabLabel, setActiveTabLabel] = useState(items[0].label);

  const updateActiveTabLabel = (activeKey: string) => {
    const activeItem = items.find((item) => item.key === activeKey);
    if (activeItem) {
      setActiveTabLabel(activeItem.label);
    } else {
      setActiveTabLabel("");
    }
  };

  const onChange = (key: string) => {
    setKey(key);
    updateActiveTabLabel(key);
  };
  const [editStatus] = useState(isEdit());
  const [, setError] = useState("");

  const onError = (error: any, variables: warehouseType, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };

  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createWarehouse" : "editWarehouse",
    !isEdit()
      ? (warehouse: warehouseType) => createWarehouse(warehouse)
      : (warehouse: warehouseType) => editWarehouse(id, warehouse),
    {
      onSuccess: (res) => {
        navigate("/warehouses");
        message.success("Complete successfully");
      },
      onError,
    }
  );

  const handleFinish = () => {
    const newwarehouse = form.getFieldsValue();
    for (const key in newwarehouse) {
      if (newwarehouse[key] === undefined) {
        if (key === "isActive") {
          newwarehouse[key] = true;
        } else {
          newwarehouse[key] = null;
        }
      } else if (
        typeof newwarehouse[key] === "string" &&
        newwarehouse[key].trim() === ""
      ) {
        newwarehouse[key] = null;
      }
    }
    mutateCreateUpdate(newwarehouse);
  };
  useEffect(() => {
    if (editStatus) {
      setName(true);
    }
  }, [editStatus]);
  return (
    <>
      <Row>
        <Col offset={1} span={20} style={{ marginBottom: "10px" }}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("inventory")}</>,
              },
              {
                title: <Link to="/warehouses">{t("warehouse-list")}</Link>,
              },
              {
                title: (
                  <>
                    {isEdit()
                      ? `${t("edit-warehouse")}`
                      : `${t("add-warehouse")}`}
                  </>
                ),
              },
              {
                title: (
                  <>
                    <span className="breadcrumbcolor">{activeTabLabel}</span>
                  </>
                ),
              },
            ]}
          />
        </Col>
        {isEdit() ? (
          <Col className="editTitle" offset={1} span={20}>
            {warehouse?.name}
          </Col>
        ) : (
          <Col className="editTitle" offset={1} span={20}>
            {t("add-warehouse")}
          </Col>
        )}
        <Row style={{ minHeight: "69vh" }}>
          <Col offset={1} span={22}>
            <Form
              onFinish={handleFinish}
              layout="vertical"
              style={{ margin: "auto" }}
              form={form}
              id="warehouseform"
              initialValues={{
                name: warehouse?.name,
                location: warehouse?.location,
                description: warehouse?.description,
                isActive: isEdit() ? warehouse?.isActive : true,
              }}
            >
              <Tabs
                data-testid="tabs-test"
                className="ant-tab"
                defaultActiveKey="1"
                activeKey={key}
                items={items}
                onChange={onChange}
              />
            </Form>
          </Col>
        </Row>
        <Col offset={1} span={4}>
          <CancelBtn data-testid="cancel-button" />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <AddEditButton
            data-testid="add-button"
            disabled={!name}
            onClick={() => {
              setOpen(true);
            }}
            isLoading={""}
          />
        </Col>
      </Row>
      <AddEditModal
        form="warehouseform"
        open={open}
        setOpen={setOpen}
        name={<span>{warehouse?.name}</span>}
        title={`${t("modal-warehouse")}`}
        isSaving={isSaving}
      />
    </>
  );
}
export default AddEditWarehouses;
